class CartWatcher {
  constructor() {
    // change this to your gift handle or variant_id
    this.giftProductHandle = "luxury-jute-black-fern-tote-bag"; 
  }

  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

  storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

  findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    };

    oldCart.items.forEach(oi => {
      const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0
        ? result.added.push(item)
        : result.removed.push(item);
    });

    return result;
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);

    await this.validateGiftProduct(newCart);

    const event = new CustomEvent("cart_changed", { detail: changes });
    window.dispatchEvent(event);

    this.storeCart(newCart);
  }

  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }

  async validateGiftProduct(cart) {
    const giftItem = cart.items.find(item => item.handle === this.giftProductHandle);
    if (giftItem && giftItem.quantity > 1) {
      console.warn("Gift item exceeds allowed quantity, adjusting…");

      await fetch(`/cart/change.js`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: giftItem.key,
          quantity: 1
        })
      });

      const correctedCart = await this.fetchCart();
      this.storeCart(correctedCart);

      // Optional: notify the customer
    //   alert("Gift product is limited to 1 per order.");
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const myCartWatcher = new CartWatcher();
  myCartWatcher.init();

  window.addEventListener("cart_changed", e => {
    console.log("Cart changed:", e.detail);
  });
});
